import { render } from "./CompareOverlay.vue?vue&type=template&id=271c6534&scoped=true"
import script from "./CompareOverlay.vue?vue&type=script&lang=js"
export * from "./CompareOverlay.vue?vue&type=script&lang=js"

import "./CompareOverlay.vue?vue&type=style&index=0&id=271c6534&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\vue_plate_tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271c6534"]])

export default __exports__